export default {
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, Array, String],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    toPortal: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    isError: Boolean,
    required: Boolean,
    multiple: Boolean,
    disabled: Boolean,
    long: Boolean,
    big: {
      type: Boolean,
      default: true,
    },
    showCode: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      currentValue: null,
      currentFullValue: null,
    };
  },
  watch: {
    value: {
      handler (value) {
        this.currentValue = value;
      },
      deep: true,
      immediate: true,
    },
    currentValue: {
      handler (value) {
        this.$emit('change', value);
      },
      deep: true,
      immediate: true,
    },
    currentFullValue: {
      handler (value) {
        this.$emit('change-full', value);
      },
      deep: true,
      immediate: false,
    },
  },
  mounted () {
    this.$bus.$on('locale-changed', () => {
      this.updateKey += 1;
    });
  },
  beforeDestroy () {
    this.$bus.$off('locale-changed', () => {
      this.updateKey += 1;
    });
  },
  methods: {
    changeFull (item) {
      this.currentFullValue = item;
    },
    addSeparator (item, keys) {
      let res = '';
      keys.forEach((key, index) => {
        if (index > 0 && !!item[key] && res.length > 0) res += ' | ';
        res += item[key] ? item[key] : '';
      });
      return res;
    },
    loaded () {
      this.$emit('loaded');
    },
  },
};
